import React, { useEffect, useState } from "react";
import axios from "axios";
import { BACKEND } from "../config/configEnvs";
import { toast } from "react-toastify";
import { Button } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { FaBirthdayCake, FaCalendar, FaCheck, FaEdit, FaFlag, FaIdCardAlt, FaMapMarkerAlt, FaMoneyBill, FaPhone, FaRegCalendarAlt, FaStar, FaSuitcase, FaTimes, FaTrash, FaUser, FaUserCog, FaUsers } from "react-icons/fa";
import AddIcon from "@mui/icons-material/Add";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import Tooltip from "../components/ui/ToolTip";
import DeleteItem from "../utils/DeleteItem";
import PaginationItem from "../components/ui/components/Pagination";
import Modal from "../components/ui/Modal";
import { MdEmail, MdMail, MdPassword, MdPerson, MdWorkspaces } from "react-icons/md";
import { ExportarColeccionExcel } from "../utils/automateFuncions/ExportarColeccionExcel";
import { useSelector } from "react-redux";
import InputFormValue from "../components/ui/components/InputFormValue";
import DeleteButton from "../components/ui/components/DeleteButton";
import EditButton from "../components/ui/components/EditButton";
import FetchRUC from "../utils/externalAPIs/FetchRuc";
import FetchDNI from "../utils/externalAPIs/FetchDNI";
import FormLoader from "../components/ui/FormLoader";
import countryCodes from "../constants/countrycodes.json";
import GetCountries from "../utils/getData/GetCountries";
import { vipClientValues } from "../utils/rawData/vipClientValues";
import HandleUpdateSelect from "../utils/HandleUpdateSelect";
import { vipClientColor } from "../utils/GetTextColor";
import { FetchRucPeru } from "../utils/externalAPIs/FetchRucPeru";

function ClientesUser() {

  const user = useSelector((state) => state.auth.user)
  const isSuperAdmin = user.area.toUpperCase() === "ADMINISTRACION" && (user.puesto.toUpperCase() === "GERENTE GENERAL" || user.area.toUpperCase() === "JEFE DE PROYECTOS")

  const [loadingStatus, setLoadingStatus] = useState(false)

  const [clientsUser, setClientsUser] = useState([]);
  const [rubros, setRubros] = useState([])
  const [nichos, setNichos] = useState([])

  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(65)
  const [totalPages, setTotalPages] = useState(0)
  const [totalDocs, setTotalDocs] = useState(0)
  
  const [newClientModal, setNewClientModal] = useState(false)
  const [editClientModal, setEditClientModal] = useState(false)

  const [clientName, setClientName] = useState("");

  const [paises, setPaises] = useState([])

  const [userToEditID, setUserToEditID] = useState("")
  const [userToEditPassword, setUserToEditPassword] = useState(false)

  const [countryNames, setCountryNames] = useState([])

  const handlePasswordToEdit = () => {
    setUserToEditPassword((prev) => {
      const newState = !prev; // Invertir el estado del checkbox

      setUserToEditForm((prevForm) => {
        if (!newState) {
          // Si se desactiva el checkbox, eliminar la propiedad 'password'
          const { password, ...rest } = prevForm;
          return rest;
        }

        // Si se activa, agregar la propiedad 'password'
        return { ...prevForm, password: "" };
      });

      return newState;
    });
  };

  const [dniVerify, setDniVerify] = useState(false)
  const [isDniLoading, setIsDniLoading] = useState(false)

  const [rucVerify, setRucVerify] = useState(false)
  const [isRucLoading, setIsRucLoading] = useState(false)

  const [userToEditForm, setUserToEditForm] = useState({ // Formulario de usuario a editar
    razonSocial: "",
    email: "",
    rubro: "",
    nicho: "",
    pais: "",
    ruc: "",
    dni: "",
    nombreComercial: "",
    fechaAniversario: "",
    direccion: "",
    tipoCliente: "",
    nEmpleados: "",
    ingresosAnuales: "",
    nombreGerente: "",
    cumpleaniosGerente: "",
    telefonoGerente: "",
    emailGerencia: "",
    encargadoProyecto: "",
    telefono: "",
    fechaCumpleanios: "",
    puestoTrabajo: "",
    activoAgencia: false,
    vip: ""
  })

  const [userToCreateForm, setUserToCreateForm] = useState({ // Formulario de usuario a crear
    razonSocial: "",
    email: "",
    password: "",
    rubro: "",
    nicho: "",
    pais: "",
    ruc: "",
    dni: "",
    nombreComercial: "",
    tipoCliente: "No definido",
    fechaAniversario: "",
    direccion: "",
    nEmpleados: "",
    ingresosAnuales: "",
    nombreGerente: "",
    cumpleaniosGerente: "",
    telefonoGerente: "+51",
    emailGerencia: "",
    encargadoProyecto: "",
    telefono: "+51",
    fechaCumpleanios: "",
    puestoTrabajo: "",
    activoAgencia: false,
    vip: "No"
  })

  const resetNewUserForm = () => {
    setUserToCreateForm({
      razonSocial: "",
      email: "",
      password: "",
      rubro: "",
      nicho: "",
      pais: "",
      ruc: "",
      dni: "",
      nombreComercial: "",
      tipoCliente: "No definido",
      fechaAniversario: "",
      direccion: "",
      nEmpleados: "",
      ingresosAnuales: "",
      nombreGerente: "",
      cumpleaniosGerente: "",
      telefonoGerente: "",
      emailGerencia: "",
      encargadoProyecto: "",
      telefono: "",
      fechaCumpleanios: "",
      puestoTrabajo: "",
      activoAgencia: false,
      vip: "No"
    })
  }

  const resetEditUserForm = () => {
    setUserToEditForm({
      razonSocial: "",
      email: "",
      password: "",
      rubro: "",
      nicho: "",
      pais: "",
      ruc: "",
      dni: "",
      nombreComercial: "",
      tipoCliente: "",
      fechaAniversario: "",
      direccion: "",
      nEmpleados: "",
      ingresosAnuales: "",
      nombreGerente: "",
      cumpleaniosGerente: "",
      telefonoGerente: "",
      emailGerencia: "",
      encargadoProyecto: "",
      telefono: "",
      fechaCumpleanios: "",
      puestoTrabajo: "",
      activoAgencia: false,
      vip: ""
    })
  }
  
  const getClients = async () => {
    try {
      setLoadingStatus(true)

      let url = `${BACKEND}/api/clientesuser?limit=${limit}&page=${page}`

      if (clientName) {
        url += `&where[nombreComercial][like]=${clientName}`
      }

      const response = await axios.get(url)

      setClientsUser(response.data.docs)
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)

    } catch (e) {
      toast.error("Error al obtener los usuarios: " + e)
    } finally {
      setLoadingStatus(false)
    }
  }

  const getRubros = async () => { // Obtenemos los rubros
    try {
      const response = await axios.get(`${BACKEND}/api/clientesRubros?limit=0`)
      setRubros(response.data.docs)
    } catch (e) {
      console.log(e)
    }
  }

  const getPaises = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/paises?limit=0`)
      setPaises(response.data.docs)
    } catch (e) {
      return false
    }
  }

  const getNichosToCreate = async (rubroId) => { // Obtenemos los nichos

    if (!userToCreateForm.rubro) {
      setNichos([])
      return
    }

    try {
      const response = await axios.get(`${BACKEND}/api/clientesNichos?limit=0&where[rubro][equals]=${rubroId}`)
      setNichos(response.data.docs)
    } catch (e) {
      console.log(e)
    }
  }

  const getNichosToUpdate = async (rubroId) => {

    if (!userToEditForm.rubro) {
      setNichos([])
      return
    }

    try {
      const response = await axios.get(`${BACKEND}/api/clientesNichos?limit=0&where[rubro][equals]=${rubroId}`)
      setNichos(response.data.docs)
    } catch (e) {
      console.log(e)
    }
  }

  const handleSubmitNewUser = async (e) => { // Crear usuarios
    try {
      e.preventDefault()
      await axios.post(`${BACKEND}/api/clientesuser`, userToCreateForm)
      toast.success("Usuario creado exitosamente!")
      setNewClientModal(false)
      resetNewUserForm()
      getClients()
    } catch (e) {
      toast.error("Error al crear el usuario: " + e)
    }
  }

  const handleSubmitEditUser = async (e) => { // Actualizar usuarios
    try {
      e.preventDefault()
      await axios.put(`${BACKEND}/api/clientesuser/${userToEditID}`, userToEditForm)
      toast.success("Usuario editado exitosamente!")
      setEditClientModal(false)
      setUserToEditID("")
      getClients()
    } catch (e) {
      toast.error("Error al actualizar el usuario: " + e)
    }
  }

  useEffect(() => {
    getClients()
    getRubros()
    getNichosToCreate()
    getPaises()
    GetCountries({setter: setCountryNames})
  }, []);

  useEffect(() => {
    getNichosToCreate(userToCreateForm.rubro);
  }, [userToCreateForm.rubro]);

  useEffect(() => {
    getNichosToUpdate(userToEditForm.rubro);
  }, [userToEditForm.rubro]);

  useEffect(() => {
    getClients()
  }, [page, limit]);

  const handleSearchClients = () => { // Buscamos clientes y colocamos página 1
    setPage(1)
    getClients()
  }

  useEffect(() => { // Solo se ejecuta cuando se vacea la barra de búsqueda
    if (clientName === "") {
      getClients()
      setPage(1)
    }
  }, [clientName]);

  const handleResetSearch = () => { // Resetea la búsqueda
    setClientName(""); // Cambiar el estado
  };

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  const formatDateForInput = (isoDate) => {
    return isoDate ? new Date(isoDate).toISOString().split("T")[0] : "";
  };

  const dniCheckHandler = async ({dni, setter}) => {
    if (dni.length < 8) {
      toast.warning("DNI inválido - debe tener 8 dígitos");
      return;
    }
    
    try {
      const nombre = await FetchDNI({
        dni: dni, 
        loadingSetter: setIsDniLoading
      });
      
      if (nombre) {
        setter((prev) => ({
          ...prev, 
          nombreGerente: nombre,
        }));
        setDniVerify(true)
        toast.success("DNI validado exitosamente");
      } else {
        toast.error("DNI no encontrado");
      }
    } catch (error) {
      toast.error("Error al validar DNI");
    }
  }

  const rucCheckHandler = async ({ruc, setter}) => {
    if (ruc.length !== 11) {
      toast.warning("RUC inválido - debe tener 11 dígitos");
      return;
    }
    
    try {
      // const { brandName, direccion } = await FetchRUC({
      //   ruc: ruc, 
      //   loadingSetter: setIsRucLoading
      // });
      // if (brandName) {
      //   setter((prev) => ({
      //     ...prev, 
      //     razonSocial: brandName,
      //     nombreComercial: brandName,
      //     direccion: direccion,
      //   }));
      //   setRucVerify(true)
      //   toast.success("RUC validado exitosamente");
      // } else {
      //   toast.error("RUC no encontrado");
      // }
      
      const { empresa, direccion } = await FetchRucPeru({ ruc: ruc, type: "ruc" });
      const { docType, dni, nombre, cargo } = await FetchRucPeru({ ruc, type: "ruc_representantes" });
      setter((prev) => ({
        ...prev, 
        razonSocial: empresa || "",
        nombreComercial: empresa || "",
        direccion: direccion || "",
        nombreGerente: nombre || "",
        puestoTrabajo: cargo || "",
        dni: dni || "",
      }));
      setRucVerify(true)
      toast.success("RUC validado exitosamente");
    } catch (error) {
      toast.error("Error al validar RUC");
    }
  }

  const formatPhoneWithDialCode = (currentPhone, dialCode) => {
    const desiredDial = (dialCode || "+51").trim();
    const phone = (currentPhone || "").toString().trim();
    if (!phone) return desiredDial;
    const leadingMatch = phone.match(/^\s*(\+\d{1,4})\s*(.*)$/);
    if (leadingMatch) {
      const existingDial = leadingMatch[1];
      const restNumber = leadingMatch[2].trim();
      if (existingDial === desiredDial) return phone; // already correct
      return restNumber ? `${desiredDial} ${restNumber}` : `${desiredDial}`;
    }
    return `${desiredDial} ${phone}`;
  }

  const countryCodeHandler = ({countryId, setter}) => {
    const country = countryNames.find(c => c.id === Number(countryId));
    const countryCode = countryCodes.find(c => c.code === country?.code);
    const dialCode = countryCode ? countryCode.dial_code : "+51";
    setter(prev => ({
      ...prev,
      telefono: formatPhoneWithDialCode(prev?.telefono, dialCode),
      telefonoGerente: formatPhoneWithDialCode(prev?.telefonoGerente, dialCode)
    }))
  }

  useEffect(() => {
    if (userToEditForm?.dni === "") {
      setDniVerify(false)
      setUserToEditForm((prev) => ({
        ...prev,
        nombreGerente: "",
      }))
    }
  }, [userToEditForm.dni])

  useEffect(() => {
    if (userToEditForm?.ruc === "") {
      setRucVerify(false)
      setUserToEditForm((prev) => ({
        ...prev,
        razonSocial: "",
        nombreComercial: "",
      }))
    }
  }, [userToEditForm.ruc])

  const cols = [
    {width: "w-[10px]", align: "center", value: "__acciones", label: "Acciones", type: "actions" },
    {width: "w-[150px]", align: "start", value: "c.nombreComercial", label: "Nombre", type: "text" },
    {width: "w-[100px]", align: "center", value: "c.vip", label: "Nivel de importancia", type: "text" },
    {width: "w-[100px]", align: "center", value: "c.nicho?.rubro?.name", label: "Rubro", type: "text" },
    {width: "w-[100px]", align: "center", value: "c.nicho?.name", label: "Nicho", type: "text" },
    {width: "w-[50px]", align: "center", value: "c.pais", label: "País", type: "text" },
    {width: "w-[80px]", align: "center", value: "c.telefono", label: "Teléfono", type: "text" },
    {width: "w-[80px]", align: "center", value: "c.ruc", label: "RUC", type: "text" },
    {width: "w-[100px]", align: "left", value: "c.nombreGerente", label: "Nombre gerente", type: "text" },
    {width: "w-[80px]", align: "center", value: "c.telefonoGerente", label: "Teléfono gerente", type: "text" },
    {width: "w-[80px]", align: "center", value: "c.tipoCliente", label: "Tipo cliente", type: "text" }
  ]

  const idCols = cols.map((col, index) => ({id: index + 1, ...col}))

  const getValueFromPath = (object, path) => {
    if (!object || !path) return undefined
    const normalizedPath = path
      .trim()
      .replace(/^c\./, "")
      .replace(/\?\./g, ".")
    return normalizedPath.split(".").reduce((acc, key) => (acc == null ? undefined : acc[key]), object)
  }

  return (
    <div className="flex flex-col h-screen w-full">

      <Modal // Modal para crear nuevos clientes
        activeModal={newClientModal}
        onClose={() => {
          setNewClientModal(false)
          resetNewUserForm()
        }}
        title="Crear nuevo cliente"
        className="max-w-3xl"
        centered
      >
        <form 
          className="max-h-[75vh] overflow-y-auto"
          onSubmit={(e) => handleSubmitNewUser(e)}
        >
          <div className="flex flex-row gap-4">

            <div className="flex flex-col w-1/2 gap-4">

              {/* RUC */}
              <div className="flex flex-col gap-2">
                <label className="text-xs block text-gray-700 mb-1">
                    RUC
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaIdCardAlt />
                  </span>
                  <input
                    type="text"
                    placeholder="RUC del usuario"
                    required
                    value={userToCreateForm.ruc}
                    onChange={(e) => setUserToCreateForm((prev) => ({...prev, ruc: e.target.value}))}
                    className="text-xs rounded-none bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />

                  {rucVerify ? (
                    <div className="inline-flex gap-2 items-center px-3 text-xs text-white bg-green-500 border border-s-0 rounded-e-0 border-gray-300 border-e-0 rounded-e-md ">
                      Validado
                      <FaCheck className=" text-white" />
                    </div>
                  ) : (
                    <button
                      type="button"
                      onClick={() => rucCheckHandler({ruc: userToCreateForm.ruc, setter: setUserToCreateForm})}
                      disabled={isRucLoading}
                      className="inline-flex  gap-2 items-center px-3 text-xs text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-s-0 rounded-e-md "
                    >
                      {isRucLoading ? (
                        <FormLoader colour={"#F64000"} className={"w-4"} />
                      ) : (
                        <>
                          Validar
                          <FaCheck />
                        </>
                      )}
                    </button>
                  )}
                </div>
              </div>

              {/* DNI */}
              <div className="">
                <label className="text-xs block text-gray-700 mb-1">
                    DNI
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaIdCardAlt />
                  </span>
                  <input
                    type="text"
                    placeholder="DNI del usuario"
                    required
                    value={userToEditForm.dni}
                    onChange={(e) => setUserToEditForm((prev) => ({...prev, dni: e.target.value}))}
                    className="text-xs rounded-none bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />

                  {dniVerify ? (
                    <div className="inline-flex gap-2 items-center px-3 text-xs text-white bg-green-500 border border-s-0 rounded-e-0 border-gray-300 border-e-0 rounded-e-md ">
                      Validado
                      <FaCheck className=" text-white" />
                    </div>
                  ) : (
                    <button
                      type="button"
                      onClick={() => dniCheckHandler({dni: userToEditForm.dni, setter: setUserToEditForm})}
                      disabled={isDniLoading}
                      className="inline-flex  gap-2 items-center px-3 text-xs text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-s-0 rounded-e-md "
                    >
                      {isDniLoading ? (
                        <FormLoader colour={"#F64000"} className={" w-4"} />
                      ) : (
                        <>
                          Validar
                          <FaCheck />
                        </>
                      )}
                    </button>
                  )}
                </div>
              </div>

              {/* Razón Social */}
              <InputFormValue
                required={true}
                title="Razón Social"
                info="Razón social del usuario"
                value={userToCreateForm.razonSocial}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, razonSocial: value }))}
                icon={<MdPerson />}
                placeholder="Razón social del usuario"
                type="text"
              />

              {/* Nombre Comercial */}
              <InputFormValue
                required={true}
                title="Nombre Comercial"
                info="Nombre comercial del usuario"
                value={userToCreateForm.nombreComercial}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, nombreComercial: value }))}
                icon={<FaIdCardAlt />}
                placeholder="Nombre comercial del usuario"
                type="text"
              />

              {/* Correo Electrónico */}
              <InputFormValue
                required={true}
                title="Correo Electrónico"
                info="Correo electrónico del usuario"
                value={userToCreateForm.email}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, email: value }))}
                icon={<MdEmail />}
                placeholder="Email del usuario"
                type="text"
              />

              {/* Contraseña */}
              <InputFormValue
                required={true}
                title="Contraseña"
                info="Contraseña del usuario"
                value={userToCreateForm.password}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, password: value }))}
                icon={<MdPassword />}
                placeholder="Contraseña del usuario"
                type="password"
              />

              {/* País */}
              <InputFormValue
                required={true}
                title="País"
                info="País del usuario"
                value={countryNames.find(country => country.name === userToCreateForm.pais)?.id || ""}
                setValue={(value) => {
                  const selectedCountry = countryNames.find(country => country.id === Number(value));
                  setUserToCreateForm(prev => ({ ...prev, pais: selectedCountry ? selectedCountry.name : "" }))
                  countryCodeHandler({countryId: value, setter: setUserToCreateForm})
                }}
                icon={<FaFlag />}
                placeholder="País del usuario"
                type="select"
                options={[
                  {label: "Selecciona un país", value: ""},
                  ...countryNames.map((country) => ({
                    value: country.id,
                    label: country.name
                  }))
                ]}
              />

              {/* Rubro */}
              <InputFormValue
                required={true}
                title="Rubro"
                info="Rubro del usuario"
                value={userToCreateForm.rubro}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, rubro: value }))}
                icon={<MdWorkspaces/>}
                placeholder="Rubro del usuario"
                type="select"
                options={[
                  {label: "Selecciona un rubro", value: ""},
                  ...rubros.map((rubro) => ({
                    value: rubro.id,
                    label: rubro.name
                  }))
                ]}
              />

              {/* Nicho */}
              <InputFormValue
                required={true}
                title="Nicho"
                info="Nicho del usuario"
                value={userToCreateForm.nicho}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, nicho: value }))}
                icon={<MdWorkspaces/>}
                placeholder="Nicho del usuario"
                type="select"
                options={[
                  {label: "Selecciona un nicho", value: ""},
                  ...nichos.map((nicho) => ({
                    value: nicho.id,
                    label: nicho.name
                  }))
                ]}
              />

              {/* Fecha Aniversario */}
              <InputFormValue
                required={true}
                title="Fecha Aniversario"
                info="Fecha de aniversario del usuario"
                value={userToCreateForm.fechaAniversario}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, fechaAniversario: value }))}
                icon={<FaIdCardAlt />}
                placeholder="Fecha de aniversario del usuario"
                type="date"
              />

              {/* Dirección */}
              <InputFormValue
                required={true}
                title="Dirección"
                info="Dirección del usuario"
                value={userToCreateForm.direccion}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, direccion: value }))}
                icon={<FaMapMarkerAlt />}
                placeholder="Dirección del usuario"
                type="text"
              />

              {/* Tipo cliente */}
              <InputFormValue
                required={true}
                title="Tipo cliente"
                info="Tipo de cliente"
                value={userToEditForm.tipoCliente}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, tipoCliente: value }))}
                icon={<FaUser />}
                placeholder="Dirección del usuario"
                type="select"
                options={[
                  {label: "No definido", value: "No definido"},
                  {label: "Amable", value: "Amable"},
                  {label: "Normal", value: "Normal"},
                  {label: "Problematico", value: "Problematico"},
                ]}
              />
            
            </div>

            <div className="flex flex-col w-1/2 gap-4">

              {/* Nombre Gerente */}
              <InputFormValue
                required={true}
                title="Nombre Gerente"
                info="Nombre del gerente"
                value={userToCreateForm.nombreGerente}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, nombreGerente: value }))}
                icon={<FaUserCog />}
                placeholder="Nombre del gerente"
                type="text"
              />

              {/* Cumpleaños Gerente */}
              <InputFormValue
                required={true}
                title="Cumpleaños Gerente"
                info="Cumpleaños del gerente"
                value={userToCreateForm.cumpleaniosGerente}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, cumpleaniosGerente: value }))}
                icon={<FaCalendar />}
                placeholder="Cumpleaños del gerente"
                type="date"
              />

              {/* Teléfono Gerente */}
              <InputFormValue
                required={true}
                title="Teléfono Gerente"
                info="Teléfono del gerente"
                value={userToCreateForm.telefonoGerente}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, telefonoGerente: value }))}
                icon={<FaPhone />}
                placeholder="Teléfono del gerente"
                type="text"
              />

              {/* Email Gerencia */}
              <InputFormValue
                required={true}
                title="Email Gerencia"
                info="Email del gerente"
                value={userToCreateForm.emailGerencia}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, emailGerencia: value }))}
                icon={<MdMail />}
                placeholder="Email del gerente"
                type="text"
              />

              {/* Encargado Proyecto */}
              <InputFormValue
                required={true}
                title="Encargado Proyecto"
                info="Encargado del proyecto"
                value={userToCreateForm.encargadoProyecto}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, encargadoProyecto: value }))}
                icon={<FaUserCog />}
                placeholder="Encargado del proyecto"
                type="text"
              />
              
              {/* Teléfono Encargado Proyecto */}
              <InputFormValue
                required={true}
                title="Teléfono Encargado Proyecto"
                info="Teléfono del encargado del proyecto"
                value={userToCreateForm.telefono}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, telefono: value }))}
                icon={<FaUserCog />}
                placeholder="Encargado del proyecto"
                type="text"
              />
              
              {/* Fecha Cumpleaños */}
              <InputFormValue
                required={true}
                title="Fecha Cumpleaños"
                info="Fecha de cumpleaños del gerente"
                value={userToCreateForm.fechaCumpleanios}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, fechaCumpleanios: value }))}
                icon={<FaBirthdayCake />}
                placeholder="Fecha de cumpleaños del gerente"
                type="date"
              />

              {/* Puesto Trabajo */}
              <InputFormValue
                required={true}
                title="Puesto Trabajo"
                info="Puesto del encargado en su empresa"
                value={userToCreateForm.puestoTrabajo}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, puestoTrabajo: value }))}
                icon={<FaSuitcase />}
                placeholder="Puesto del encargado en su empresa"
                type="text"
              />

              {/* Número Empleados */}
              <InputFormValue
                required={true}
                title="Número Empleados"
                info="Número de empleados del usuario o empresa"
                value={userToCreateForm.nEmpleados}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, nEmpleados: value }))}
                icon={<FaUsers />}
                placeholder="Número de empleados del usuario o empresa"
                type="text"
              />

              {/* Ingresos Anuales */}
              <InputFormValue
                title="Ingresos Anuales"
                info="Ingresos anuales del cliente"
                value={userToCreateForm.ingresosAnuales}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, ingresosAnuales: value }))}
                icon={<FaMoneyBill />}
                placeholder="Ingresos anuales del cliente"
                type="text"
              />

              {/* VIP */}
              <InputFormValue
                title="VIP"
                info="¿Cliente VIP?"
                value={userToCreateForm.vip}
                setValue={(value) => setUserToCreateForm(prev => ({ ...prev, vip: value }))}
                icon={<FaStar />}
                placeholder="¿Cliente VIP?"
                type="select"
                options={vipClientValues.map((option) => ({
                  value: option.value,
                  label: option.label
                }))}
              />
              
              {/* Activo agencia */}
              <div className="flex flex-row gap-4 items-center justify-center mt-4">
                <label className="text-xs block text-gray-700">
                  Activo agencia
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center p-2 text-sm text-gray-900 bg-gray-200 border border-gray-300 rounded-md">
                    <Tooltip content="Activo agencia">
                      <input
                        type="checkbox"
                        checked={userToCreateForm.activoAgencia}
                        onChange={() => setUserToCreateForm(prev => ({ ...prev, activoAgencia: !prev.activoAgencia }))}
                        className="rounded-md border-gray-400 hover:cursor-pointer"
                      />
                    </Tooltip>
                  </span>

                </div>
              </div>
            
            </div>
         
          </div>

          <Button 
              variant="contained"
              type="submit"
              sx={{
                fontWeight: "bold",
                fontFamily: "poppins",
                paddingBlock: "4px",
                backgroundColor: "#ff6400",
                transform: "all",
                marginTop: "20px",
                animationDuration: "1000",
                textTransform: "none",
                borderRadius: "8px",
                width: "100%",
                '&:hover': {
                  backgroundColor: "#bb4a03",
                }
              }}
            >
              Guardar
          </Button>

        </form>
      </Modal>

      <Modal // Modal para editar usuarios
        activeModal={editClientModal}
        className="max-w-3xl"
        title="Actualizar cliente"
        onClose={() => {
          setEditClientModal(false)
          setUserToEditID("")
          resetEditUserForm()
        }}
      >
        <form 
          className="max-h-[75vh] overflow-y-auto"
          onSubmit={(e) => handleSubmitEditUser(e)}
        >
          <div className="flex flex-row gap-4">

            <div className="flex flex-col w-1/2 gap-4">

              {/* RUC */}
              <div className="">
                <label className="text-xs block text-gray-700 mb-1">
                    RUC
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaIdCardAlt />
                  </span>
                  <input
                    type="text"
                    placeholder="RUC del usuario"
                    required
                    value={userToEditForm.ruc}
                    onChange={(e) => setUserToEditForm((prev) => ({...prev, ruc: e.target.value}))}
                    className="text-xs rounded-none bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />

                  {rucVerify ? (
                    <div className="inline-flex gap-2 items-center px-3 text-xs text-white bg-green-500 border border-s-0 rounded-e-0 border-gray-300 border-e-0 rounded-e-md ">
                      Validado
                      <FaCheck className=" text-white" />
                    </div>
                  ) : (
                    <button
                      type="button"
                      onClick={() => rucCheckHandler({ruc: userToEditForm.ruc, setter: setUserToEditForm})}
                      disabled={isRucLoading}
                      className="inline-flex  gap-2 items-center px-3 text-xs text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-s-0 rounded-e-md "
                    >
                      {isRucLoading ? (
                        <FormLoader colour={"#F64000"} className={"w-4"} />
                      ) : (
                        <>
                          Validar
                          <FaCheck />
                        </>
                      )}
                    </button>
                  )}
                </div>
              </div>

              {/* DNI */}
              <div className="">
                <label className="text-xs block text-gray-700 mb-1">
                    DNI
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <FaIdCardAlt />
                  </span>
                  <input
                    type="text"
                    placeholder="DNI del usuario"
                    required
                    value={userToEditForm.dni}
                    onChange={(e) => setUserToEditForm((prev) => ({...prev, dni: e.target.value}))}
                    className="text-xs rounded-none bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />

                  {dniVerify ? (
                    <div className="inline-flex gap-2 items-center px-3 text-xs text-white bg-green-500 border border-s-0 rounded-e-0 border-gray-300 border-e-0 rounded-e-md ">
                      Validado
                      <FaCheck className=" text-white" />
                    </div>
                  ) : (
                    <button
                      type="button"
                      onClick={() => dniCheckHandler({dni: userToEditForm.dni, setter: setUserToEditForm})}
                      disabled={isDniLoading}
                      className="inline-flex  gap-2 items-center px-3 text-xs text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-s-0 rounded-e-md "
                    >
                      {isDniLoading ? (
                        <FormLoader colour={"#F64000"} className={" w-4"} />
                      ) : (
                        <>
                          Validar
                          <FaCheck />
                        </>
                      )}
                    </button>
                  )}
                </div>
              </div>

              {/* Razón Social */}
              <InputFormValue
                required={true}
                title="Razón Social"
                info="Razón social del usuario"
                value={userToEditForm.razonSocial}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, razonSocial: value }))}
                icon={<MdPerson />}
                placeholder="Razón social del usuario"
                type="text"
              />

              {/* Nombre Comercial */}
              <InputFormValue
                required={true}
                title="Nombre Comercial"
                info="Nombre comercial del usuario"
                value={userToEditForm.nombreComercial}
                setValue={(value) => {setUserToEditForm(prev => ({ ...prev, nombreComercial: value }))}}
                icon={<FaIdCardAlt />}
                placeholder="Nombre comercial del usuario"
                type="text"
              />

              {/* Correo Electrónico */}
              <InputFormValue
                required={true}
                title="Correo Electrónico"
                info="Correo electrónico del usuario"
                value={userToEditForm.email}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, email: value }))}
                icon={<MdEmail />}
                placeholder="Email del usuario"
                type="text"
              />

              {/* Contraseña */}
              <div className="">
                <label className="text-xs block text-gray-700 mb-1">
                  Contraseña <span className=" text-red-500">*</span>
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
                    <MdPassword />
                  </span>
                  <input
                    type="text"
                    placeholder="Contrasña del usuario"
                    value={userToEditForm.password}
                    disabled={!userToEditPassword}
                    required
                    onChange={(e) => setUserToEditForm(prev => ({...prev, password: e.target.value}))}
                    className="text-xs bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5" 
                  />
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-s-0 border-gray-300 border-s-0 rounded-e-md ">
                    <Tooltip content="Actualizar contraseña">
                      <input
                        type="checkbox"
                        checked={userToEditPassword}
                        onChange={() => handlePasswordToEdit()}
                        className="rounded-md border-gray-400 hover:cursor-pointer"
                      />
                    </Tooltip>
                  </span>

                </div>
              </div>

              {/* País */}
              <InputFormValue
                required={true}
                title="País"
                info="País del usuario"
                value={countryNames.find(country => country.name === userToEditForm.pais)?.id || ""}
                setValue={(value) => {
                  const selectedCountry = countryNames.find(country => country.id === Number(value));
                  setUserToEditForm(prev => ({ ...prev, pais: selectedCountry ? selectedCountry.name : "" }))
                  countryCodeHandler({countryId: value, setter: setUserToEditForm})
                }}
                icon={<FaFlag />}
                placeholder="País del usuario"
                type="select"
                options={countryNames.map((country) => ({
                  value: country.id,
                  label: country.name
                }))}
              />

              {/* Rubro */}
              <InputFormValue
                required={true}
                title="Rubro"
                info="Rubro del usuario"
                value={userToEditForm.rubro}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, rubro: value }))}
                icon={<MdWorkspaces/>}
                placeholder="Rubro del usuario"
                type="select"
                options={[
                  {label: "No definido", value: ""},
                  ...rubros.map((rubro) => ({
                    value: rubro.id,
                    label: rubro.name
                  }))
                ]}
              />

              {/* Nicho */}
              <InputFormValue
                required={true}
                title="Nicho"
                info="Nicho del usuario"
                value={userToEditForm.nicho}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, nicho: value }))}
                icon={<MdWorkspaces/>}
                placeholder="Nicho del usuario"
                type="select"
                options={nichos.map((nicho) => ({
                  value: nicho.id,
                  label: nicho.name
                }))}
              />

              {/* Fecha Aniversario */}
              <InputFormValue
                required={true}
                title="Fecha Aniversario"
                info="Fecha de aniversario del usuario"
                value={userToEditForm.fechaAniversario}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, fechaAniversario: value }))}
                icon={<FaRegCalendarAlt />}
                placeholder="Fecha de aniversario del usuario"
                type="date"
              />

              {/* Dirección */}
              <InputFormValue
                required={true}
                title="Dirección"
                info="Dirección del usuario"
                value={userToEditForm.direccion}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, direccion: value }))}
                icon={<FaMapMarkerAlt />}
                placeholder="Dirección del usuario"
                type="text"
              />

              {/* Tipo cliente */}
              <InputFormValue
                required={true}
                title="Tipo cliente"
                info="Tipo de cliente"
                value={userToEditForm.tipoCliente}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, tipoCliente: value }))}
                icon={<FaUser />}
                placeholder="Dirección del usuario"
                type="select"
                options={[
                  {label: "No definido", value: "No definido"},
                  {label: "Amable", value: "Amable"},
                  {label: "Normal", value: "Normal"},
                  {label: "Problematico", value: "Problematico"},
                ]}
              />
            
            </div>

            <div className="flex flex-col w-1/2 gap-4">

              {/* Nombre Gerente */}
              <InputFormValue
                required={true}
                title="Nombre Gerente"
                info="Nombre del gerente"
                value={userToEditForm.nombreGerente}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, nombreGerente: value }))}
                icon={<FaUserCog />}
                placeholder="Nombre del gerente"
                type="text"
              />

              {/* Cumpleaños Gerente */}
              <InputFormValue
                required={true}
                title="Cumpleaños Gerente"
                info="Cumpleaños del gerente"
                value={userToEditForm.cumpleaniosGerente}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, cumpleaniosGerente: value }))}
                icon={<FaCalendar />}
                placeholder="Cumpleaños del gerente"
                type="date"
              />

              {/* Teléfono Gerente */}
              <InputFormValue
                required={true}
                title="Teléfono Gerente"
                info="Teléfono del gerente"
                value={userToEditForm.telefonoGerente}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, telefonoGerente: value }))}
                icon={<FaPhone />}
                placeholder="Teléfono del gerente"
                type="text"
              />

              {/* Email Gerencia */}
              <InputFormValue
                required={true}
                title="Email Gerencia"
                info="Email del gerente"
                value={userToEditForm.emailGerencia}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, emailGerencia: value }))}
                icon={<MdMail />}
                placeholder="Email del gerente"
                type="text"
              />

              {/* Encargado Proyecto */}
              <InputFormValue
                required={true}
                title="Encargado Proyecto"
                info="Encargado del proyecto"
                value={userToEditForm.encargadoProyecto}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, encargadoProyecto: value }))}
                icon={<FaUserCog />}
                placeholder="Encargado del proyecto"
                type="text"
              />

              {/* Teléfono Encargado Proyecto */}
              <InputFormValue
                required={true}
                title="Teléfono Encargado Proyecto"
                info="Teléfono del encargado del proyecto"
                value={userToEditForm.telefono}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, telefono: value }))}
                icon={<FaUserCog />}
                placeholder="Encargado del proyecto"
                type="text"
              />

              {/* Fecha Cumpleaños */}
              <InputFormValue
                required={true}
                title="Fecha Cumpleaños"
                info="Fecha de cumpleaños del gerente"
                value={userToEditForm.fechaCumpleanios}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, fechaCumpleanios: value }))}
                icon={<FaBirthdayCake />}
                placeholder="Fecha de cumpleaños del gerente"
                type="date"
              />

              {/* Puesto Trabajo */}
              <InputFormValue
                required={true}
                title="Puesto Trabajo"
                info="Puesto del encargado en su empresa"
                value={userToEditForm.puestoTrabajo}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, puestoTrabajo: value }))}
                icon={<FaSuitcase />}
                placeholder="Puesto del encargado en su empresa"
                type="text"
              />

              {/* Número Empleados */}
              <InputFormValue
                required={true}
                title="Número Empleados"
                info="Número de empleados del usuario o empresa"
                value={userToEditForm.nEmpleados}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, nEmpleados: value }))}
                icon={<FaUsers />}
                placeholder="Número de empleados del usuario o empresa"
                type="text"
              />

              {/* Ingresos Anuales */}
              <InputFormValue
                title="Ingresos Anuales"
                info="Ingresos anuales del cliente"
                value={userToEditForm.ingresosAnuales}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, ingresosAnuales: value }))}
                icon={<FaMoneyBill />}
                placeholder="Ingresos anuales del cliente"
                type="text"
              />

              {/* VIP */}
              <InputFormValue
                title="VIP"
                info="¿Cliente VIP?"
                value={userToEditForm.vip}
                setValue={(value) => setUserToEditForm(prev => ({ ...prev, vip: value }))}
                icon={<FaStar />}
                placeholder="¿Cliente VIP?"
                type="select"
                options={vipClientValues.map((option) => ({
                  value: option.value,
                  label: option.label
                }))}
              />

              {/* Activo agencia */}
              <div className="flex flex-row gap-4 items-center justify-center mt-4">
                <label className="text-xs block text-gray-700">
                  Activo agencia <span className=" text-red-500">*</span>
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center p-2 text-sm text-gray-900 bg-gray-200 border border-gray-300 rounded-md">
                    <Tooltip content="Activo agencia">
                      <input
                        type="checkbox"
                        checked={userToEditForm.activoAgencia}
                        onChange={() => setUserToEditForm(prev => ({ ...prev, activoAgencia: !prev.activoAgencia }))}
                        className="rounded-md border-gray-400 hover:cursor-pointer"
                      />
                    </Tooltip>
                  </span>

                </div>
              </div>
            
            </div>
         
          </div>

          <Button 
              variant="contained"
              type="submit"
              sx={{
                fontWeight: "bold",
                fontFamily: "poppins",
                paddingBlock: "4px",
                backgroundColor: "#ff6400",
                transform: "all",
                marginTop: "20px",
                animationDuration: "1000",
                textTransform: "none",
                borderRadius: "8px",
                width: "100%",
                '&:hover': {
                  backgroundColor: "#bb4a03",
                }
              }}
            >
              Actualizar
          </Button>

        </form>
      </Modal>

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100 mb-1">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <div className="flex items-center gap-4 py-4">
            <FaUsers className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Clientes usuarios</h2>
          </div>
          
          {isSuperAdmin && (
            <ExportarColeccionExcel collecion="clientesUser" query="&where[activoAgencia][not_equals]=true" />
          )}

          <div className="flex flex-row gap-4 items-center justify-center">
          
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Límite:</span>
              <select
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="25">25</option>
                <option value="35">35</option>
                <option value="45">45</option>
                <option value="55">55</option>
                <option value="65">65</option>
              </select>
            </div>

            <div className="relative w-full">
              <input
                type="text"
                placeholder="Buscar cliente"
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={clientName}
                onChange={(e) => setClientName(e.target.value)}
              />
              {clientName && (
                <FaTimes
                  onClick={() => handleResetSearch()}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>

            <div>
              <Button
                variant="contained"
                endIcon={<SearchIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => handleSearchClients()}
              >
                Buscar
              </Button>
            </div>

            <div className="pl-4">
              <Button
                variant="contained"
                endIcon={<AddIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "3px 24px",
                  whiteSpace: "nowrap",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => setNewClientModal(true)}
              >
                Crear nuevo cliente
              </Button>
            </div>

          </div>

        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
          <LoadingScreen />
        ) : clientsUser.length === 0 ? (
          <NoDataScreen />
        ) : (
          <table className="w-full table-fixed">
            <thead className="bg-white sticky top-0 z-20">
              <tr className="text-gray-700 text-center text-xs font-bold">
                {idCols.map((col, i) => (
                  col.value === "__acciones" ? (
                    <th key={i + 1} className={`px-6 py-4 ${col.width} text-center bg-[#FE6400] border-r border-r-white text-white border-red`}>
                      <div className="flex flex-row gap-4 items-center justify-center w-full ">
                        <Tooltip content="Eliminar lead">
                          <div className="font-bold hover:underline transition-all duration-100 text-white">
                            <FaTrash />
                          </div>
                        </Tooltip>
                        <Tooltip content="Ver trackeo del lead">
                          <div className="font-bold hover:underline transition-all duration-100 text-white">
                            <FaEdit />
                          </div>
                        </Tooltip>
                      </div>
                    </th>
                  ) : (
                    <th key={i + 1} className={`px-2 py-3 ${col.width} text-center bg-[#FE6400] border-r border-r-white text-white border-red`}>
                      {col.label}
                    </th>
                  )
                ))}
              </tr>
            </thead>
            <tbody>
              {clientsUser.map((c, i) => {
                return (
                  <tr key={i} className="text-xs py-2 w-full hover:bg-gray-100 transition-all duration-100">
                    {idCols.map((col) => (
                      col.value === "__acciones" ? (
                        <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">
                          <div className="flex flex-row gap-4 items-center justify-center w-full ">
                            <DeleteButton
                              action={() => DeleteItem(c.id, "clientesuser", setClientsUser)}
                              content="Eliminar usuario"
                            />
                            <EditButton
                              action={() => {
                                setEditClientModal(true)
                                setUserToEditID(c.id)
                                setUserToEditForm({
                                razonSocial: c.razonSocial || "",
                                email: c.email || "",
                                password: c.password || "", 
                                rubro: c.nicho?.rubro?.id || "",
                                nicho: c.nicho?.id || "",
                                pais: c.pais || "",
                                ruc: c.ruc || "",
                                dni: c.dni || "",
                                nombreComercial: c.nombreComercial || "",
                                tipoCliente: c.tipoCliente || "No definido",
                                fechaAniversario: formatDateForInput(c.fechaAniversario) || "",
                                direccion: c.direccion || "",
                                nEmpleados: c.nEmpleados || "",
                                ingresosAnuales: c.ingresosAnuales || "",
                                nombreGerente: c.nombreGerente || "",
                                cumpleaniosGerente: formatDateForInput(c.cumpleaniosGerente || ""),
                                telefonoGerente: c.telefonoGerente || "",
                                emailGerencia: c.emailGerencia || "",
                                encargadoProyecto: c.encargadoProyecto || "",
                                telefono: c.telefono || "",
                                fechaCumpleanios: formatDateForInput(c.fechaCumpleanios) || "",                              
                                puestoTrabajo: c.puestoTrabajo || "",
                                activoAgencia: c.activoAgencia || false,
                                vip: c.vip || ""
                              })
                                setDniVerify(false)
                                setRucVerify(false)
                              }}
                              content="Editar usuario"
                            />
                          </div>
                        </td>
                      ) : (
                        <td key={col.id} className={`px-2 py-3 ${col.width} ${col.align === "center" ? "text-center" : "text-start"} border border-gray-300`}>
                          {col.label === "Nombre" ? (
                            <div className="flex items-center gap-2">
                              {(() => {
                                const matchCountry = paises.find(p => (p?.name || "").toLowerCase() === (c?.pais || "").toLowerCase())
                                return matchCountry?.bandera?.url ? (
                                  <img src={matchCountry.bandera.url} alt="flag" className="w-5 h-5 rounded-full object-cover border" />
                                ) : null
                              })()}
                              <span className="truncate">
                                {(() => {
                                  const rawValue = getValueFromPath(c, col.value)
                                  return rawValue ?? "-"
                                })()}
                              </span>
                              {(() => {
                                return c?.vip === "Si" ? (
                                  <span title="Cliente VIP" className="hover:cursor-pointer">⭐</span>
                                ) : (
                                  c?.vip === "Importante" ? (
                                    <span title="Cliente importante" className="hover:cursor-pointer">📌</span>
                                  ) : (
                                    null
                                  )
                                )
                              })()}
                            </div>
                          ) : col.label === "Nivel de importancia" ? (
                            <select
                              value={c?.vip}
                              className={`text-xs rounded-md px-2 py-1 border border-gray-300 ${vipClientColor[c?.vip]}`}
                              onChange={(e) => {
                                HandleUpdateSelect("vip", e.target.value, c?.id, "clientesUser", setClientsUser)
                              }}
                            >
                              {vipClientValues.map((option, i) => (
                                <option key={i + 1} value={option.value} className={`${vipClientColor[option.value]}`}>{option.icon} {option.label}</option>
                              ))}
                            </select>
                          ) : (
                            (() => {
                              const rawValue = getValueFromPath(c, col.value)
                              return rawValue ?? "-"
                            })()
                          )}
                        </td>
                      )
                    ))}
                  </tr>
                )
              })}
            </tbody>
          </table>
        )}
      </div>

      {/* Paginador */}
      <PaginationItem
        actualDocs={clientsUser.length}
        totalDocs={totalDocs}
        entity={"usuarios"}
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={handlePageChange}
      />
      
    </div>
  );
}

export default ClientesUser;

{/* {clientsUser.map((c, i) => (
  <tr key={i} className="text-xs py-2 w-full hover:bg-gray-100 transition-all duration-100">
    <td className="px-6 py-4 max-w-xs truncate border border-gray-300 text-center">
      <div className="flex flex-row gap-4 items-center justify-center w-full ">
        <DeleteButton
          action={() => DeleteItem(c.id, "clientesuser", setClientsUser)}
          content="Eliminar usuario"
        />

        <EditButton
          action={() => {
            setEditClientModal(true)
            setUserToEditID(c.id)
            setUserToEditForm({
            razonSocial: c.razonSocial || "",
            email: c.email || "",
            password: c.password || "", 
            rubro: c.nicho?.rubro?.id || "",
            nicho: c.nicho?.id || "",
            pais: c.pais || "",
            ruc: c.ruc || "",
            dni: c.dni || "",
            nombreComercial: c.nombreComercial || "",
            tipoCliente: c.tipoCliente || "No definido",
            fechaAniversario: formatDateForInput(c.fechaAniversario) || "",
            direccion: c.direccion || "",
            nEmpleados: c.nEmpleados || "",
            ingresosAnuales: c.ingresosAnuales || "",
            nombreGerente: c.nombreGerente || "",
            cumpleaniosGerente: formatDateForInput(c.cumpleaniosGerente || ""),
            telefonoGerente: c.telefonoGerente || "",
            emailGerencia: c.emailGerencia || "",
            encargadoProyecto: c.encargadoProyecto || "",
            telefono: c.telefono || "",
            fechaCumpleanios: formatDateForInput(c.fechaCumpleanios) || "",                              
            puestoTrabajo: c.puestoTrabajo || "",
            activoAgencia: c.activoAgencia || false,
            vip: c.vip || ""
          })
            setDniVerify(false)
            setRucVerify(false)
          }}
          content="Editar usuario"
        />
      </div>
    </td>
    <td className="max-w-xs px-8 border border-gray-300 text-center">
      <div className="flex flex-row gap-2 items-center justify-between">
        <span className="truncate">{c.nombreComercial}</span>
        {c.pais && (
          <Tooltip content={paises.find(p => NormalizeText(p.name) === NormalizeText(c.pais))?.name || "País no encontrado"}>
            <div className="w-4 h-4 z-10">
              <img src={paises.find(p => NormalizeText(p.name) === NormalizeText(c.pais))?.bandera?.url} alt="flag" className="w-4 h-4" />
            </div>
          </Tooltip>
        )}  
      </div>
    </td>
    <td className="max-w-xs px-2 truncate border border-gray-300 text-center">
      {c.nicho?.rubro?.name}
    </td>
    <td className="max-w-xs px-2 truncate border border-gray-300 text-center">
      {c.nicho?.name}
    </td>
    <td className="max-w-xs px-2 truncate border border-gray-300 text-center">
      {c.pais}
    </td>
    <td className="max-w-xs px-2 truncate border border-gray-300 text-center">
      {c.telefono}
    </td>
    <td className="max-w-xs px-2 truncate border border-gray-300 text-center">
      {c.ruc}
    </td>
    <td className="max-w-xs px-2 truncate border border-gray-300 text-center">
      {c.nombreGerente}
    </td>
    <td className="max-w-xs px-2 truncate border border-gray-300 text-center">
      {c.telefonoGerente}
    </td>
    <td className="max-w-xs px-2 truncate border border-gray-300 text-center">
      {c.tipoCliente}
    </td>
  </tr>
))} */}
